import { Button, Result } from "antd";
export default function CoumstFallbackComponent({ error }: { error: Error }) {
  return (
    <Result
      status="error"
      title="Failed!"
      subTitle={
        <div>
          <p>Something went wrong.</p>
          <p>{error.message}</p>
        </div>
      }
      extra={[
        <Button
          type="primary"
          key="console"
          onClick={() => {
            window.location.replace("/");
          }}
        >
          Go to home
        </Button>,
        <Button
          key="buy"
          onClick={() => {
            window.location.reload();
          }}
        >
          Click Retry
        </Button>,
      ]}
    ></Result>
  );
}
